/* eslint-disable */
import React, { useEffect, useState } from "react";
import { LuExternalLink } from "react-icons/lu";
import plus500 from "./../assets/img/Plus500.svg";
import IG from "./../assets/img/IG.png";
import Pepperstone from "./../assets/img/Pepperstone.png";
import City from "./../assets/img/City Index.png";
import { Link } from "react-router-dom";
import Instance from "../utils/Interceptor";

function CenteroneGermany() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchBrokerData = async () => {
    // setLoading(true);
    try {
      setLoading(true);
      const response = await Instance.get("api/germany-broker-point");
      // const Fee = response.data.data.slice(0, 41);
      setData(response?.data?.data);
      if (response.data.status === true) {
        setLoading(false);
        window.scrollTo(0, 0);
      } else {
        setLoading(true);
      }
    } catch (error) {
      console.error("Error fetching broker data:", error);
      setLoading(true);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchBrokerData();
    // scrollTo(0,0)
  }, []);
  return (
    <div className="">
      <h1 className=" fw-bold pt-2 py-3 text-center">
        Best Forex Brokers For Germany
      </h1>
      <div className="container sidePadding">
        <p className="text-justify container">
          To find the best forex brokers in Germany, we created a list of all
          brokers that list Germany as a country they accept new customers from.
          We then ranked brokers by their Overall ranking.
        </p>
      </div>
      <div className="container sidePadding">
        <p className="text-justify container">
          Here is our list of the best forex brokers for Germany:
        </p>
      </div>

      <p className=" mt-2 text-center">
        {" "}
        *The spreads are not fixed and are subject to change (Last update on
        04-04-2025)
      </p>

      {data?.map((e, i) => {
        return (
         <div className="container my-3 shadow-lg">
                      {/* Desktop View (unchanged) */}
                      <div className="d-none d-md-block">
                        <div className="row my-3 g-3 align-items-center py-5">
                          {/* Profile Section */}
                          <div className="col-lg-2 col-md-4 col-sm-12">
                            <div className="d-flex align-items-start p-3 resFee">
                              <img
                                src={e?.image}
                                alt=""
                                width="77"
                                height="77"
                                style={{
                                  borderRadius: "10px",
                                  cursor: "pointer",
                                  boxShadow: "5px 5px 10px rgba(0,0,0,.23)",
                                }}
                              />
                              <div className="px-3">
                                <h6 className="fw-bold fs-6 mb-1">{""}</h6>
                                <h6 className="fw-bold fs-6 para-color type">{""}</h6>
                              </div>
                            </div>
                          </div>
                    
                          {/* General Info Section */}
                          <div className="col-lg-4 col-md-8 col-sm-12">
                            <div className="text-start">
                              <p className="para-color mb-2">General Info</p>
                              <ul className="ps-3 mb-0">
                                {e?.levels.slice(0, 4)?.map((item, i) => (
                                  <li key={i}>{item?.point}</li>
                                ))}
                              </ul>
                            </div>
                          </div>
                    
                          {/* Spread Section */}
                          <div className="col-lg-2 col-md-6 col-sm-12">
                            <div className="text-start">
                              <p className="para-color mb-2">Average Spread</p>
                              <ul className="ps-3 mb-0">
                                {e?.levels.slice(4, 8)?.map((item, i) => (
                                  <li key={i}>{item?.point}</li>
                                ))}
                              </ul>
                            </div>
                          </div>
                    
                          {/* Button + Review Link Section */}
                          <div className="col-lg-4 col-md-6 col-sm-12 d-flex flex-column align-items-center justify-content-center text-center">
                            <div className="link-btn pb-3">
                              <div className="theme-btn btn-style-two">
                                <span
                                  className="btn-title"
                                  onClick={() => window.open(e?.url, "_blank")}
                                  style={{ padding: "3px 7px", cursor: "pointer" }}
                                >
                                  VISIT BROKER{" "}
                                  <LuExternalLink
                                    size="22"
                                    style={{ paddingBottom: "5px" }}
                                  />
                                </span>
                              </div>
                            </div>
                            <div className="hint">
                              <Link to={e?.path} className="forhover">
                                <span style={{ borderBottom: "1px solid #0a2cd4" }}>
                                  Read review
                                </span>
                              </Link>
                            </div>
                           <div className="mt-2">{e?.loss_point}</div>
                          </div>
                        </div>
                      </div>
                    
                      {/* Mobile Card View - Centered with shadow only */}
                      <div className="d-md-none p-3">
                        <div className="shadow-lg rounded-3 p-3" style={{ background: 'transparent' }}>
                          {/* Profile Section - Centered */}
                          <div className="d-flex flex-column align-items-center mb-4">
                            <img
                              src={e?.image}
                              alt=""
                              width="80"
                              height="80"
                              className="mb-2"
                              style={{
                                borderRadius: "10px",
                                cursor: "pointer",
                                boxShadow: "3px 3px 6px rgba(0,0,0,.15)",
                              }}
                            />
                            <h6 className="fw-bold mb-1 text-center">{""}</h6>
                            <h6 className="text-muted small text-center">{""}</h6>
                          </div>
                    
                          {/* General Info Section - Centered */}
                          <div className="mb-4 text-center">
                            <p className="text-muted mb-2 fw-medium">General Info</p>
                            <div className="d-flex flex-column gap-1">
                              {e?.levels.slice(0, 4)?.map((item, i) => (
                                <span key={i}>{item?.point}</span>
                              ))}
                            </div>
                          </div>
                    
                          {/* Spread Section - Centered */}
                          <div className="mb-4 text-center">
                            <p className="text-muted mb-2 fw-medium">Average Spread</p>
                            <div className="d-flex flex-column gap-1">
                              {e?.levels.slice(4, 8)?.map((item, i) => (
                                <span key={i}>{item?.point}</span>
                              ))}
                            </div>
                          </div>
                    
                          {/* Button + Review Link Section - Centered */}
                          <div className="d-flex flex-column align-items-center gap-2 mt-3">
                            <button
                              className="btn btn-primary px-4 py-2"
                              onClick={() => window.open(e?.url, "_blank")}
                              style={{ minWidth: '180px' }}
                            >
                              VISIT BROKER <LuExternalLink size="16" className="ms-1" />
                            </button>
                            <Link 
                              to={e?.path} 
                              className="text-primary text-decoration-none"
                              style={{ borderBottom: "1px solid #0a2cd4" }}
                            >
                              Read review
                            </Link>
                           <div className="mt-1">{e?.loss_point}</div>
                          </div>
                        </div>
                      </div>
                    </div>
        );
      })}
      <div className="container" style={{ paddingLeft: "100px" }}>
        <h1 className=" fw-bold pt-2 py-3 text-center">
          How to Verify BaFin Authorisation
        </h1>
        <p className="text-justify container">
          To identify if a forex broker is authorised by BaFin, the first step
          is to identify the BaFin registration number from the disclosure text
          at the bottom of the broker’s homepage. For example, here’s the key
          disclosure text from IG’s website,
        </p>
        <p className="text-justify container">
          IG Markets Ltd. is authorized and regulated by the Financial Conduct
          Authority (FCA Registry Number 195355). The IG Europe GmbH is
          supervised by the Federal Financial Supervisory Authority (BaFin
          registration number 148759) and the German Central Bank. IG is a brand
          name of IG Markets Ltd.
        </p>
        <p className="text-justify container">
          Next, look up the registration number on the{" "}
          <a href="https://portal.mvp.bafin.de/database/InstInfo/">
            {" "}
            financial register{" "}
          </a>{" "}
          available on BaFin’s website to validate that the broker is currently
          authorized in Germany
        </p>
      </div>
    </div>
  );
}

export default CenteroneGermany;
